import { MuscleIntensity } from '@/generated';
import { MuscleIntensityListItem, TagIntensity } from './TagIntensity';
import { List, ListSubheader, Stack } from '@mui/material';
import { exerciseDetailsListSubheaderStyle } from '@/styles';

interface TagIntensityListProps {
  muscleIntensities: Array<MuscleIntensity>;
  editable?: boolean;
  elementClicked?: (bzti: MuscleIntensity, deleted?: boolean) => void;
}

export const TagIntensityList = (props: TagIntensityListProps) => {
  return (
    <>
      {props.muscleIntensities?.map((bzti) => (
        <TagIntensity key={bzti.muscleId} muscleIntensity={bzti} editable={props.editable} elementClicked={props.elementClicked} />
      ))}
    </>
  );
};

export const MuscleTagIntensityList = (props: TagIntensityListProps) => {
  return (
    <List
      component={Stack}
      direction="row"
      flexWrap="wrap"
      gap={1}
      sx={{
        display: 'inline-flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        p: 0,
        m: 0,
        listStyle: 'none',
        width: '100%',
        justifyContent: 'flex-start',
      }}
    >
      <ListSubheader sx={{ width: '100%', ...exerciseDetailsListSubheaderStyle }}>Muscles:</ListSubheader>
      {props.muscleIntensities?.map((bzti) => (
        <MuscleIntensityListItem key={bzti.muscleId} muscleIntensity={bzti} />
      ))}
    </List>
  );
};
